<template>
  <div v-sticky="{ zIndex: 9, stickyTop: 60}" class="jin-pc-category">
    <h3 v-if="show">{{ title }}</h3>
    <ul v-if="category.length" class="jin-pc-category-warp">
      <li v-for="item in category" :key="item.name" class="jin-pc-category-item" :class="{'jin-pc-category-item-active' : item.name === curr}" @click="onChange(item)">
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'

export default {
  directives: {
    'sticky': VueSticky
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    category: {
      type: Array,
      default: () => []
    },
    active: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '职位类别'
    }
  },
  data() {
    return {
      curr: ''
    }
  },
  computed: {
    currActive() {
      return this.$route.query.title
    }
  },
  watch: {
    active(n) {
      this.curr = n
    },
    category: {
      handler(n) {
        // console.log(n)
        this.init()
      },
      deep: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.curr = this.currActive || this.active
      const item = {
        name: this.curr,
        id: this.category.length ? this.category.find(item => item.name === this.curr).id : ''
      }
      this.$emit('change', item)
    },
    onChange(item) {
      this.$emit('change', item)
      if (this.$route.path.includes('list')) {
        this.$router.replace({
          path: '/list',
          query: { ...this.$route.query, title: item.name }
        })
      }
    }
  }
}
</script>
